module.exports = __webpack_public_path__ + "static/assets/3ea1f0c44114b8930830e941f25f2b85.png";